import { render, staticRenderFns } from "./menulist.vue?vue&type=template&id=e50035f0&scoped=true"
import script from "./menulist.vue?vue&type=script&lang=js"
export * from "./menulist.vue?vue&type=script&lang=js"
import style0 from "./menulist.vue?vue&type=style&index=0&id=e50035f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50035f0",
  null
  
)

export default component.exports